// Helper for development-only logging
// Automatically enabled on: localhost, test, preprod, uat environments
// Disabled by default on production (web.mypatientspace.com)
//
// Usage in production: Enable via console with:
//   localStorage.setItem('ENABLE_DEV_LOGS', 'true')
// Disable with:
//   localStorage.removeItem('ENABLE_DEV_LOGS')
// Or disable in dev environments:
//   localStorage.setItem('DISABLE_DEV_LOGS', 'true')

const DEV_ENVIRONMENTS = [
  'localhost',
  '127.0.0.1',
  'test.mypatientspace.com',
  'preprod.mypatientspace.com',
  'uat.mypatientspace.com'
];

const isDevEnvironment = () => {
  const hostname = window.location.hostname;
  return DEV_ENVIRONMENTS.includes(hostname);
};

export const devLog = (...args) => {
  // Check explicit disable flag (for dev environments)
  if (localStorage.getItem('DISABLE_DEV_LOGS') === 'true') {
    return;
  }

  // Check explicit enable flag (for production)
  const forceEnabled = localStorage.getItem('ENABLE_DEV_LOGS') === 'true';

  // Log if: explicitly enabled OR running in dev environment
  if (forceEnabled || isDevEnvironment()) {
    console.log(...args);
  }
};